import custom from './custom';
import promoteJob from './promoteJob';
import scheduleJobs from './scheduleJobs';
import promoteJobs from './promoteJobs';
import promoteContent from './promoteContent';
import promoteContentShares from './promoteContentShares';
import scheduleContentShares from './scheduleContentShares';
import invite from './invite';
import leaderboardIndividual from './leaderboardIndividual';
import leaderboardOverall from './leaderboardOverall';
import collectiveGoal from './collectiveGoal';
import gamificationUpdateIndividual from './gamificationUpdateIndividual';
import promoteInternalJob from './promoteInternalJob';
import promoteInternalJobs from './promoteInternalJobs';

import lnwCustom from './lnw/custom';
import lnwPromoteJob from './lnw/promoteJob';
import lnwScheduleJobs from './lnw/scheduleJobs';
import lnwPromoteJobs from './lnw/promoteJobs';
import lnwPromoteContent from './lnw/promoteContent';
import lnwPromoteContentShares from './lnw/promoteContentShares';
import lnwScheduleContentShares from './lnw/scheduleContentShares';
import lnwInvite from './lnw/invite';
import lnwLeaderboardIndividual from './lnw/leaderboardIndividual';
import lnwLeaderboardOverall from './lnw/leaderboardOverall';
import lnwCollectiveGoal from './lnw/collectiveGoal';
import lnwGamificationUpdateIndividual from './lnw/gamificationUpdateIndividual';

export default client => {
  if (client === 'lnw') {
    return [
      lnwCustom,
      lnwInvite,
      lnwPromoteJob,
      lnwPromoteJobs,
      lnwScheduleJobs,
      lnwPromoteContent,
      lnwPromoteContentShares,
      lnwScheduleContentShares,
      lnwLeaderboardIndividual,
      lnwLeaderboardOverall,
      lnwCollectiveGoal,
      lnwGamificationUpdateIndividual
    ];
  }
  return [
    custom,
    invite,
    promoteJob,
    promoteInternalJob,
    promoteJobs,
    promoteInternalJobs,
    scheduleJobs,
    promoteContent,
    promoteContentShares,
    scheduleContentShares,
    leaderboardIndividual,
    leaderboardOverall,
    collectiveGoal,
    gamificationUpdateIndividual
  ];
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/index.js